app.directive('board', [function() {
    return {
        restrict: "EA",
        templateUrl: function(elem, attrs) {
            return 'template_' + attrs.boardId + '.html'
        },
        scope: {
            boardId: "=",
            boardDuration: "="
        },
        controller: ['$scope', '$timeout', function($scope, $timeout) {
            $timeout(function() {
                $scope.$emit('board-finished');
            }, $scope.boardDuration);
        }],
        link: function(scope, elem, attrs) {

        }
    }
}]);